// removed by extract-text-webpack-plugin
module.exports = {"container":"styles-container--3JL7A","list":"styles-list--2gETu","detail":"styles-detail--2e1uW","listFilter":"styles-listFilter--3kJqu","listItems":"styles-listItems--RRW1x","active":"styles-active--3Ko7W","report":"styles-report--3NatH","summaryContainer":"styles-summaryContainer--1up8J","summaryBox":"styles-summaryBox--3mEYP","futureTravelContainer":"styles-futureTravelContainer--35xDt","futureTravelBox":"styles-futureTravelBox--1Llpa","settings":"styles-settings--3K4Ba","splitList":"styles-splitList--3tRF6"};


//////////////////
// WEBPACK FOOTER
// /src/components/Reports/styles.scss
// module id = 81cR
// module chunks = 1